import React from 'react';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import SettlementFeeItemTab from './SettlementFeeItemTab';
import PricingFeeItemTab from './PricingFeeItemTab';

const SettlementFeeItemPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Tabs
      defaultActiveKey="settlement"
      items={[
        { key: 'settlement', label: t('central.settlementFeeItem.settlementFeeItemManagement'), children: <SettlementFeeItemTab /> },
        { key: 'pricing', label: t('central.settlementFeeItem.pricingFeeItemManagement'), children: <PricingFeeItemTab /> },
      ]}
    />
  );
};

export default SettlementFeeItemPage;
